import { StyledTooltip, TooltipContent, TooltipSelf } from '~/core/components/tooltip/common'
import type { TooltipPropsType } from '~/core/components/tooltip/common'

export const DesktopTooltip = (props: TooltipPropsType) => (
  <StyledTooltip placement="bottom" arrow title={<TooltipContent>{props.content}</TooltipContent>}>
    <TooltipSelf>{props.self}</TooltipSelf>
  </StyledTooltip>
)
